import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class Hit extends XYEffect {
	static key = "Hit";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
